import React from 'react';
import LazyImage from '../LazyImage';
import './Services.css';
import advisoryIcon from '../../assets/icons/advisory.webp';
import taxServicesIcon from '../../assets/icons/tax-services.webp';
import businessIcon from '../../assets/icons/business.webp';
import superannuationIcon from '../../assets/icons/Superannuation.webp';

const Services = () => {
    const servicesData = [
        {
            id: 1,
            icon: advisoryIcon,
            title: "Business Advisory",
            description: "Strategic advice focused on performance, efficiency, and long-term growth. PFGS helps unlock your business's full potential through hands-on guidance tailored to your goals."
        },
        {
            id: 2,
            icon: taxServicesIcon,
            title: "Tax Services",
            description: "Personalised solutions for individuals and businesses across all tax areas — including direct, indirect, and employment taxes. No generic advice — only what fits your exact needs."
        },
        {
            id: 3,
            icon: businessIcon,
            title: "Business Services",
            description: "Daily support for smooth operations, accurate reporting, and process automation. From bookkeeping to compliance, we keep your finances running efficiently."
        },
        {
            id: 4,
            icon: superannuationIcon,
            title: "Superannuation",
            description: "Clear, compliant SMSF and super tax support. PFGS simplifies super fund management and helps you stay on top of your retirement reporting obligations."
        }
    ];

    return (
        <section className="services">
            <div className="services-container">
                <div className="services-content">
                    <div className="services-header">
                        <div className="services-tag">Services</div>
                        <h2 className="services-title">
                            Trusted Tax, Accounting & Business <br className="desktop-break" />
                            <span className="text-primary">Services That Work for You</span>
                        </h2>
                        <p className="services-description">
                            At PFGS, we deliver reliable, personalised services to individuals, sole traders, and
                            small businesses — helping you stay compliant, save money, and grow with
                            confidence.
                        </p>
                    </div>

                    <div className="services-cards">
                        {servicesData.map((service) => (
                            <div key={service.id} className="service-card">
                                <div className="service-icon">
                                    <LazyImage src={service.icon} alt={service.title} />
                                </div>
                                <div className="service-content">
                                    <h3 className="service-title">{service.title}</h3>
                                    <p className="service-description">{service.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Services;